import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { apiMethods, apiEndPoints } from '@constants/index';
import { IApiResponse } from '@core/models/index';

@Injectable()
export class PaymentsService {
  constructor(private readonly http: ApiService) {}
  public paymentCharge(itrId, stripeToken): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.post,
      path: `${apiEndPoints.payment}${apiEndPoints.paymentCharge}`,
      body: { itr: itrId, token: stripeToken },
    });
  }
  public paymentDetails(itrId): Observable<IApiResponse> {
    return this.http.invoke({
      method: apiMethods.get,
      path: `${apiEndPoints.payment}${apiEndPoints.paymentDetail}/${itrId}`,
    });
  }
}
